import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Restore scroll position when returning to a page via the back button
 * Note: This hook should be used in conjunction with keepContentScrollPosition in an onClick handler
 * @example onClick={keepContentScrollPosition}
 */
export const useContentScrollPosition = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    if (location.state?.prev) {
      let storedScrollPosition = localStorage.getItem('contentScroll');
      let content = document.querySelector('.content');
      if (content && storedScrollPosition !== null) {
        content.scrollTop = Number(storedScrollPosition);
      }
    }
  }, [location.state?.prev]);
};

export const keepContentScrollPosition = () => {
  let content = document.querySelector('.content');
  content && localStorage.setItem('contentScroll', content.scrollTop.toString());
};
